import { catchError, filter, map, mergeMap, withLatestFrom } from 'rxjs/operators';

import { Epic } from 'redux-observable';
import { RootAction } from 'store/actions';
import { RootDependencies } from 'store/dependencies';
import { RootState } from 'store/reducer';
import { fetchHosts as fetchHostsAction } from './actions';
import { isActionOf } from 'typesafe-actions';
import { of } from 'rxjs';
import { getErrorCode } from 'store/utils';

export const fetchHosts: Epic<RootAction, RootAction, RootState, RootDependencies> = (action$, state$, { apiClient }) =>
  action$.pipe(
    filter(isActionOf(fetchHostsAction.request)),
    withLatestFrom(state$),
    mergeMap(([{ payload }, state]) => {
      return apiClient(state)
        .fetchHosts(payload)
        .pipe(
          map(({ response }) => fetchHostsAction.success({ hosts: response, params: payload })),
          catchError((error: Error) => of(fetchHostsAction.failure({ error, errorCode: getErrorCode(error) }))),
        );
    }),
  );
